import React, { FC, useState, useEffect, useRef } from 'react';

interface IFile {
    id: string;
    name: string;
    label: string;
    error: string;
    fileName: any;
    formData: any;
    setFormData: (state: any) => void;
    setFormErrors: (state: any) => void;
    isFormDataCleared: boolean;
}

const File: FC<IFile> = ({ id, name, label, fileName, formData, setFormData, setFormErrors, isFormDataCleared }: IFile) => {
    const [ currentFileName, setCurrentFileName ] = useState<string>('');

    const fileRef = useRef<HTMLInputElement>(null);

    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();

        let file: any = null;

        if (event.target.files) {
            file = event.target.files[0];
        }

        setFormData((state: any) => {
            return {
                ...state,
                // @ts-ignore
                // [name]: [...state[name], ...event.target.files],
                [name]: file,
            }
        });

        setFormErrors && setFormErrors((state: any) => {
            return {
                ...state,
                [name]: ''
            }
        });
    };

    useEffect(() => {
        setCurrentFileName(fileName?.name);
    }, [fileName]);

    useEffect(() => {
        if (!formData[name].length) {

            const input = fileRef.current;
            if (input) {
                input.value = '';
            }

            setCurrentFileName('');
        }

    }, [isFormDataCleared]);

    return (
        <div className="file__input-box">
            <label
                className="file__input-label"
                htmlFor={id}
            >
                {label}
                <input
                    className="file__input"
                    ref={fileRef}
                    type="file"
                    id={id}
                    onChange={onChangeHandler}
                />
            </label>
            <p className="file__name">{currentFileName}</p>
        </div>
    );
};

export default React.memo(File);
